import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../core/api/api";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import {
  AgentDashboardCountsApiRes,
  AgentLeaderBoardDataApiRes,
  agentPerformanceKpi,
  AgentScoringSentiments,
  CallSentimentVsScore,
  DashboardCountsApiRes,
  FailureCountCategoryApiRes,
  PurposeCallDistribution,
  TopTenViolations,
} from "../core/types/chatterscore";

export const getAuditList = createAsyncThunk(
  "audit/getAuditList",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.audit_list}${data}`);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const putOffensiveWordNotification = createAsyncThunk(
  "callEvaluation/updateProfanityNotification",
  async (updateObj: {
    call_evaluation_id: string;
    is_offensive_notification_cleared: string;
  }) => {
    return await axiosInstance.put(
      Api.update_Offensive_Word_Notification,
      updateObj
    );
  }
);
export const checkAccessStatus = createAsyncThunk(
  "auth/checkAccessStatus",
  async (params: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.check_access_status}${params}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const projectListApi = createAsyncThunk(
  "auth/projectList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.project_list}?limit=200&q=`
      );
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getAuditDetails = createAsyncThunk(
  "auth/details",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.details}?call_evaluation_id=${id}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const loadFileAndKid = createAsyncThunk(
  "auth/loadFileAndKid",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.load_file_and_kid}?recording_id=${id}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const sendKeyAuthorizedUser = createAsyncThunk(
  "auth/sendKeyAuthorizedUser",
  async ({ id, kid }: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.send_key_authorized_user}?recording_id=${id}&kid=${kid}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateManualReview = createAsyncThunk(
  "auth/updateManualReview",
  async (updateObj: object, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        Api.manual_review,
        updateObj
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateCallEvaluationStatus = createAsyncThunk(
  "auth/changeStatus",
  async (updateObj: object, thunkAPI) => {
    try {
      const response = await axiosInstance.put(Api.change_status, updateObj);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getActionStatus = createAsyncThunk(
  "auth/getActionStatus",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.get_action_status}?ca_audit_id=${id}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const AccessStartEndTime = createAsyncThunk(
  "auth/AccessStartEndTime",
  async (updateObj: object) => {
    return await axiosInstance.put(Api.access_start_end_time, updateObj);
  }
);

export const getManualReview = createAsyncThunk(
  "audit/getManualReview",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.manual_review}?call_evaluation_id=${id}`
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const agentDashboardCounts = createAsyncThunk<
  AgentDashboardCountsApiRes,
  string
>("auth/agentDashboard", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`${Api.agent_dashboard}${param}`);
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const evaluationDashboardCounts = createAsyncThunk<
  DashboardCountsApiRes[],
  string
>("auth/dashboardCounts", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.evaluation_dashboard}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const agentLeaderBoardData = createAsyncThunk<
  AgentLeaderBoardDataApiRes[],
  string
>("audit/agentLeaderboard", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.agent_leader_board}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});
export const agentOutlierReportData = createAsyncThunk<
  AgentLeaderBoardDataApiRes[],
  string
>("audit/agentOutlierReportBoard", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.outlier_agent_report}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});
export const failureCountByCategoryChart = createAsyncThunk<
  FailureCountCategoryApiRes,
  string
>("audit/failureCountCategory", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.failure_count_category}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const agentScoringSentiments = createAsyncThunk<
  AgentScoringSentiments,
  string
>("audit/agentScoringSentiments", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.agent_scoring_sentiments}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getTopViolationsByCategories = createAsyncThunk<any[], string>(
  "audit/getTopViolationsByCategories",
  async (param, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.top_violations_by_categories}${param}`
      );
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getCampaigns = createAsyncThunk("audit/campaigns", async () => {
  return await axiosInstance.get(Api.campaigns);
});
export const topTenViolationsByCategories = createAsyncThunk<
  TopTenViolations,
  string
>("audit/topTenViolations", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.top_ten_violations}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});
export const getAgentList = createAsyncThunk("audit/agent", async () => {
  return await axiosInstance.get(Api.agent);
});
export const getQaSupervisorList = createAsyncThunk(
  "audit/qa_supervisor",
  async () => {
    return await axiosInstance.get(Api.qa_supervisor);
  }
);
export const getAgentPerformanceKpis = createAsyncThunk<
  agentPerformanceKpi,
  string
>("audit/agentPerformanceKpis", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.agent_performance_kpi}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getPurposeCallDistribution = createAsyncThunk<
  PurposeCallDistribution,
  string
>("audit/purposeCallDistribution", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.purpose_call_distribution}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});
export const getCallSentimentVsScore = createAsyncThunk<
  CallSentimentVsScore,
  string
>("audit/getCallSentimentVsScore", async (param, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `${Api.call_sentiment_vs_score}${param}`
    );
    return response?.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getSentimentWordCloud = createAsyncThunk(
  "audit/sentiment_word_cloud",
  async (id: any) => {
    return await axiosInstance.get(
      `${Api.sentiment_word_cloud}?call_evaluation_id=${id}`
    );
  }
);

export const getSentimentAnalysis = createAsyncThunk(
  "audit/sentiment_analysis",
  async (id: any) => {
    return await axiosInstance.get(
      `${Api.sentiment_analysis}?call_evaluation_id=${id}`
    );
  }
);

export const getEmotionAnalysis = createAsyncThunk(
  "audit/emotion_analysis",
  async (id: any) => {
    return await axiosInstance.get(
      `${Api.emotion_analysis}?call_evaluation_id=${id}`
    );
  }
);

export const getSentimentTiming = createAsyncThunk(
  "audit/sentiment_timing",
  async (id: any) => {
    return await axiosInstance.get(
      `${Api.sentiment_timing}?call_evaluation_id=${id}`
    );
  }
);

export const getConversationalTagMappings = createAsyncThunk(
  "audit/getConversationalTagMappings",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.conversational_tag_mappings}${data}`);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getConversationalTags = createAsyncThunk(
  "audit/getConversationalTags",
  async () => {
    const response = await axiosInstance.get(Api.conversational_tags);
    return response.data;
  }
);